import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function DocumentReviewAction({
  active,
  label,
  children,
  className,
}: {
  active: boolean;
  label: string;
  children: ReactNode;
  className?: string;
}) {
  const { t } = useTranslation();

  return (
    <div
      role={active ? 'group' : undefined}
      aria-label={active ? t('documentReview.actionRequired', { action: label }) : undefined}
      className={className}
    >
      {children}
    </div>
  );
}
